'use strict';

Object.defineProperty(exports, "__esModule", {
			value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GeckoLabelModel = {
			name: _propTypes2.default.string.isRequired,
			type: _propTypes2.default.oneOf([_constants.GECKO_CONSTS.LABEL_TYPE_DANGER, _constants.GECKO_CONSTS.LABEL_TYPE_DEFAULT, _constants.GECKO_CONSTS.LABEL_TYPE_PRIMARY, _constants.GECKO_CONSTS.LABEL_TYPE_INFO, _constants.GECKO_CONSTS.LABEL_TYPE_SUCCESS, _constants.GECKO_CONSTS.LABEL_TYPE_WARNING])
};

exports.default = GeckoLabelModel;